import {
  MaterialColumns,
  MaterialUsecaseInterface,
  UpdateListParams,
  UpdateParams,
  UpdateStatusParams,
} from "./usecase.d";
import { MaterialRepository } from "../../services/Material/material.repository";
import * as MaterialReducer from "./reducer";
import { ActionType } from "./types";
import { GetListParams } from "../../services/Material/material.repository.d";
import { LocalStorage } from "../../modules/LocalStorage";
import { GetMaterialDto } from "../../services/Material/dto/get.dto";

const MATERIAL_COLUMN_KEY = "MaterialColumns";

const defaultColumns: MaterialColumns = {
  materialThumbnailUrl: true,
  materialKey: true,
  name: true,
  materialCategories: true,
  materialUnitPrice: true,
  materialRooms: true,
  materialSurfaces: true,
  materialManufacturer: true,
  homeNames: true,
  updatedByFullName: true,
  updatedAt: true,
  isActive: true,
};

export class MaterialUsecase implements MaterialUsecaseInterface {
  dispatch: MaterialReducer.MaterialDispatch;
  repository: MaterialRepository;

  constructor(dispatch: MaterialReducer.MaterialDispatch) {
    this.repository = new MaterialRepository();
    this.dispatch = dispatch;
  }

  async getList(params: GetListParams): Promise<GetMaterialDto[]> {
    const response = await this.repository.getList(params);

    this.dispatch({
      type: ActionType.GetList,
      items: response,
    });
    return response;
  }

  async update(params: UpdateParams) {
    try {
      const response = await this.repository.update({
        materialKey: params.materialKey,
        name: params.name,
        materialCategory: params.materialCategory,
        materialUnitPrice: params.materialUnitPrice,
        isActive: params.isActive,
        userId: params.userId,
      });
      this.dispatch({
        type: ActionType.Update,
        updatedItem: response.data,
      });
    } catch (error) {
      console.info("ahihi");
      throw error;
    }
  }

  async updateList(params: UpdateListParams) {
    try {
      const response = await this.repository.updateList({
        userId: params.userId,
        items: params.items,
      });
      this.dispatch({
        type: ActionType.UpdateList,
        updatedItems: response.data.Items,
      });
    } catch (error) {
      console.info("ahihi");
      throw error;
    }
  }

  async updateStatus(params: UpdateStatusParams) {
    this.dispatch({
      type: ActionType.UpdateStatus,
      updatedStatusItem: params,
    });

    try {
      await this.repository.update({
        materialKey: params.materialKey,
        isActive: params.isActive,
      });
    } catch (error) {
      this.dispatch({
        type: ActionType.UpdateStatus,
        updatedStatusItem: {
          materialKey: params.materialKey,
          isActive: !params.isActive,
        },
      });
      throw error;
    }
  }

  getDisplayColumns() {
    const columns =
      LocalStorage.getShowHideColumns<MaterialColumns>(MATERIAL_COLUMN_KEY);

    if (
      !columns ||
      Object.keys(defaultColumns).length !== Object.keys(columns).length
    ) {
      return defaultColumns;
    }
    return columns;
  }

  setDisplayColumns(columns: MaterialColumns) {
    LocalStorage.setShowHideColumns(MATERIAL_COLUMN_KEY, columns);
  }
}
